module.exports = __webpack_public_path__ + "static/media/strategicpartnersselect.1189f405.png";